module.exports = __webpack_public_path__ + "static/img/200003.ebb0ae67.png";